export default {
    en: {
        number: 10,
        diagramId: 9,
        answers: 'plants sense and respond to Suspect brain-like processing',
        interactiveBoxNumber: [1, 2],
        blocks:
            [
                {
                    task: {
                        question: 'Plant microbiologists see evidence that plants sense and respond to environmental variables',
                        answer: '<span class="correct-answer-box">Plant microbiologists see evidence that <span class="highlight__answer highlight__answer_correct">plants sense and respond to</span> environmental variables</span>'
                    },
                    example: true
                },
                {
                    task: {
                        question: 'Suspect they have a sophisticated, brain-like information processing and signalling system to sense and respond',
                        answer: '<span class="correct-answer-box"><span class="highlight__answer highlight__answer_correct">Suspect</span> they have a sophisticated, <br><span class="highlight__answer highlight__answer_correct">brain-like</span> information <span class="highlight__answer highlight__answer_correct">processing</span> and signalling system to sense and respond</span>'
                    },
                    selectAvailable: true
                },
                {
                    task: {
                        question: 'But without an actual brain, think their intelligence may be organized In a network, like insect colonies',
                        answer: '<span class="correct-answer-box">But without an actual brain, think their <span class="highlight__answer highlight__answer_correct">intelligence may be organized In a network</span>, like insect colonies</span>'
                    },
                    selectAvailable: true
                },
                {
                    task: {
                        question: 'Thus they are researching how networks can inspire brainy behaviour in the absence of actual brains',
                        answer: '<span class="correct-answer-box">Thus they are researching how networks can inspire brainy behaviour in the absence of actual brains</span>'
                    }
                }
            ]
    }
};



// WEBPACK FOOTER //
// ./client/app/modules/courses/3/3a1/deductiveReasoning/i18n/exercise10.js